import { jsxs as o, Fragment as t, jsx as r } from "react/jsx-runtime";
const C = () => /* @__PURE__ */ o(t, { children: [
  /* @__PURE__ */ r(
    "path",
    {
      d: "M9.31066 19.1893C9.89644 19.7751 9.89644 20.7249 9.31066 21.3107C8.72487 21.8964 7.77513 21.8964 7.18934 21.3107C6.60355 20.7249 6.60355 19.7751 7.18934 19.1893C7.77513 18.6036 8.72487 18.6036 9.31066 19.1893Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M19.0607 19.1893C19.6464 19.7751 19.6464 20.7249 19.0607 21.3107C18.4749 21.8964 17.5251 21.8964 16.9393 21.3107C16.3536 20.7249 16.3536 19.7751 16.9393 19.1893C17.5251 18.6036 18.4749 18.6036 19.0607 19.1893Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M1.5 3H3.75L7.19531 15.4012C7.37552 16.0504 7.96635 16.4997 8.64 16.5H17.9062C18.5803 16.5001 19.1716 16.0507 19.3519 15.4012L21.75 6.75H4.79156",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }
  )
] });
export {
  C as default
};
